import { Box } from '../../components/ui/box';
import { Skeleton } from '../../components/ui/skeleton';
import type { Omittable } from "../../lib/props";

export function KanbanColumnSkeleton({
  count = 3,
  height = 68,
}: Omittable<{
  count?: number;
  height?: number;
}>) {
  return (
    <Box direction="column" gap="sm" padding="xs" fill="width">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="w-full" style={{ height }} />
      ))}
    </Box>
  );
}

// Placeholder for a not-yet-loaded slot in a windowed column. Sized to the
// virtualizer's row estimate so the scroll track stays stable as the card swaps in.
export function KanbanCardSkeleton({ height }: { height: number }) {
  return <Skeleton className="w-full" style={{ height }} />;
}
